import { render, staticRenderFns } from "./DetailsEquipe.vue?vue&type=template&id=a4c4a610&"
import script from "./DetailsEquipe.vue?vue&type=script&lang=ts&"
export * from "./DetailsEquipe.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsEquipe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports